<script>
  import { BASE_URL } from "../../stores/BASE_URL"
  import { createEventDispatcher } from "svelte"
  import { user } from "../../stores/User"

  const dispatch = createEventDispatcher()

  let session_key = $user.session_key

  let segmentos = []
  let productos = []
  let productos_por_segmento = []
  let cliente = {
    tipo_doc: "DNI",
    documento: "",
    nombres: "",
    descripcion: "",
    id_segmento: "0",
    id_producto: "1",
    session_key: session_key,
  }
  let isAdding = false

  const addCliente = async () => {
    if (
      cliente.nombres.trim() === "" ||
      cliente.documento.trim() === "" ||
      cliente.id_segmento === "0"
    ) {
      alert("Por favor, complete todos los campos.")
      return
    }

    isAdding = true

    if ((await checkCliente()) == "si") {
      if (
        !confirm(
          "El cliente ya existe en el segmento seleccionado. ¿Desea continuar?",
        )
      ) {
        isAdding = false
        return
      }
    }

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "addCliente",
        ...cliente,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      dispatch("close")
      dispatch("update")
    } else {
      alert("Error al agregar cliente: " + data.message)
    }
    isAdding = false
  }

  const getNombres = async () => {
    if (cliente.documento.trim() === "" || cliente.documento.length < 8) {
      cliente.nombres = ""
      return
    }

    const response = await fetch(
      `${BASE_URL}crm.php?ops=getRecursosByDocumento&tipo_doc=DNI&documento=${cliente.documento}&session_key=${session_key}`,
    )
    const resp = await response.json()
    if (resp.status === "ok") {
      cliente.nombres = resp.data.generales.nombres
    } else {
      cliente.nombres = ""
    }
  }

  const getSegmentos = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getSegmentos&session_key=${session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      //Solo segmentos activos
      segmentos = data.data.filter((seg) => seg.estado === "1")
    } else {
      segmentos = []
    }
  }

  const getProductos = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=getProductos&session_key=${session_key}`,
    )
    const data = await response.json()
    if (data.status === "ok") {
      productos = data.data
    } else {
      productos = []
    }
  }

  const checkCliente = async () => {
    const response = await fetch(
      `${BASE_URL}crm.php?ops=checkCliente&id_segmento=${cliente.id_segmento}&documento=${cliente.documento}&session_key=${session_key}`,
    )
    const data = await response.json()

    if (data.status !== "ok") {
      return "no"
    }
    return data.exists
  }

  $: if (cliente.id_segmento !== "1") {
    productos_por_segmento = productos.filter(
      (prod) => prod.id_segmento === cliente.id_segmento && prod.estado === "1",
    )
  } else {
    productos_por_segmento = []
    cliente.id_producto = "1"
  }

  getSegmentos()
  getProductos()
</script>

<div>
  <div class="mb-3">
    <label for="tipo_doc" class="form-label">Tipo Doc.</label>
    <select
      id="tipo_doc"
      class="form-control form-control-sm"
      bind:value={cliente.tipo_doc}
      on:change={getNombres}
    >
      <option value="DNI">DNI</option>
      <option value="CARNET EXT.">CARNET EXT.</option>
    </select>
  </div>

  <div class="mb-3">
    <label for="documento" class="form-label">Documento</label>
    <input
      type="text"
      id="documento"
      class="form-control form-control-sm"
      bind:value={cliente.documento}
      on:input={getNombres}
    />
  </div>

  <div class="mb-3">
    <label for="nombres" class="form-label">Nombres</label>
    <input
      type="text"
      id="nombres"
      class="form-control form-control-sm"
      disabled
      bind:value={cliente.nombres}
    />
  </div>

  <div class="mb-3">
    <label for="segmento" class="form-label">Segmento</label>
    <select
      id="segmento"
      class="form-control form-control-sm"
      bind:value={cliente.id_segmento}
    >
      <option value="0">Seleccione un segmento</option>
      {#each segmentos as segmento}
        <option value={segmento.id}>{segmento.nombre}</option>
      {/each}
    </select>
  </div>

  <div class="mb-3">
    <label for="producto" class="form-label">Producto</label>
    <select
      id="producto"
      class="form-control form-control-sm"
      bind:value={cliente.id_producto}
    >
      <option value="1">SIN PRODUCTO</option>
      {#each productos_por_segmento as producto}
        <option value={producto.id}>{producto.nombre}</option>
      {/each}
    </select>
  </div>

  <div class="mb-3 text-end">
    {#if isAdding}
      <button class="btn btn-solid theme-primary btn-sm disabled" disabled
        ><i class="bi bi-plus"></i>Agregando...</button
      >
    {:else}
      <button class="btn btn-solid theme-primary btn-sm" on:click={addCliente}
        ><i class="bi bi-plus"></i>Agregar</button
      >
    {/if}
  </div>
</div>
